module.exports = __webpack_public_path__ + "img/bg_login_img.b54361b1.jpg";